export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6092.85d2ed28.jpg";